import SavedFilter, {SavedFilterDto} from "./SavedFilter"
import HttpClient from "../helpers/HttpClient"
import {HttpError, isError} from "../helpers/Error"

class SavedFilterService {
    httpClient: HttpClient<SavedFilter, SavedFilterDto> = new HttpClient<SavedFilter, SavedFilterDto>(SavedFilter)

    async getAllDashboardSavedFilters() : Promise<HttpError|SavedFilter[]>{
        const res = await this.httpClient.get("/saved-filters/dashboard")
        if (isError(res)) {
            return res as HttpError
        }
        return res as SavedFilter[]
    }
}

const instance = new SavedFilterService()
export default instance


// WEBPACK FOOTER //
// ./src/state/listing/SavedFilterService.ts